import { render, staticRenderFns } from "./GraphDetail84.vue?vue&type=template&id=85f53210&scoped=true"
import script from "./GraphDetail84.vue?vue&type=script&lang=js"
export * from "./GraphDetail84.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f53210",
  null
  
)

export default component.exports